import React, { FC, PropsWithChildren, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { selectIsLoggedIn } from 'app/redux/selectors/auth';

import { RestorePassword } from '../RestorePassword';
import { closeSigningDialog } from '../Signing/actions'; //
import { SigningDialog as SigningDialogNew2 } from '../Signing/components/SigningDialog';
import { CHECK_ICON_TIME_DURATION } from '../Signing/constants';
import { AUTH_QUERY_KEY, AuthModalQuery } from '../Signing/utils/auth-modals-query';

const Layout: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();

  const isLogged = useSelector(selectIsLoggedIn);
  const timerId = useRef<number>();

  const [hasAccess, setAccess] = useState(!isLogged);
  const { replace, location: { search } } = useHistory();

  const searchParams = new URLSearchParams(search);

  const signing = searchParams.get(AUTH_QUERY_KEY);

  const killTimer = () => {
    if (typeof timerId.current === 'number') {
      clearTimeout(timerId.current);
      timerId.current = undefined;
    }
  };

  useEffect(() => {
    if (isLogged && signing === AuthModalQuery.LOGIN) {
      dispatch(closeSigningDialog());

      const from = searchParams.get('from');

      if (from) {
        replace({ pathname: from });
      }

      timerId.current = window.setTimeout(() => {
        setAccess(false);

        timerId.current = undefined;
      }, CHECK_ICON_TIME_DURATION);
    }
    else {
      killTimer();
      setAccess(true);
    }
  }, [isLogged]);

  const dialog = useMemo(() => {
    if (signing === AuthModalQuery.LOGIN || signing === AuthModalQuery.SIGN){
      return <SigningDialogNew2 />;
    }
    if (signing === AuthModalQuery.RESTORE_PASSWORD) {
      return <RestorePassword />;
    }
  }, [signing]);

  return (
    <>
      {children}

      {hasAccess && (
        dialog
      )}
    </>
  );
};

export default Layout;
